// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","Fallback":"xVbmi8","fadeInFrames":"_2dTEfx"};